import gql from 'graphql-tag';

const CREATE_WORKLOG_TIMER = gql`
  mutation($ticketId: ID, $worklogTimer: WorklogTimerInput!) {
    createWorklogTimer(ticketId: $ticketId, input: $worklogTimer) {
      timerId
      offering {
        offeringId
        name
        type
      }
      billable
      technician {
        userId
        name
        firstName
        lastName
      }
      state
      timespent
    }
  }
`;

const UPDATE_WORKLOG_TIMER = gql`
  mutation($timerId: ID!, $worklogTimer: WorklogTimerInput!) {
    updateWorklogTimer(timerId: $timerId, input: $worklogTimer) {
      timerId
      offering {
        offeringId
        name
        type
      }
      billable
      technician {
        userId
        name
        firstName
        lastName
      }
      state
      timespent
    }
  }
`;

export { CREATE_WORKLOG_TIMER, UPDATE_WORKLOG_TIMER };
